import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getJournalBySlug,
  getUserProgress,
} from "../services/moneyMagicService";
import UntangleHome from "./UntangleHome";
import "./MoneyMagicRouter.css";

const getSessionFromStorage = () => {
  try {
    const storageKey = Object.keys(localStorage).find(
      (k) => k.includes("sb-") && k.includes("-auth-token")
    );
    if (!storageKey) return null;
    const raw = localStorage.getItem(storageKey);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return { userId: parsed?.user?.id };
  } catch {
    return null;
  }
};

function UntangleRouter() {
  const navigate = useNavigate();
  // "checking" | "home" | "redirecting"
  const [status, setStatus] = useState("checking");
  const [journal, setJournal] = useState(null);
  const [progress, setProgress] = useState(null);

  useEffect(() => {
    let alive = true;

    const run = async () => {
      const session = getSessionFromStorage();
      if (!session?.userId) {
        navigate("/login", { replace: true });
        return;
      }

      const journalData = await getJournalBySlug("the-untangle-journal");
      if (!alive) return;

      if (!journalData) {
        // Journal not found in DB — should not happen once data is seeded
        navigate("/", { replace: true });
        return;
      }
      if (alive) setJournal(journalData);

      // No premium/purchase check — this journal is free for all logged-in users
      const userProgress = await getUserProgress(session.userId, journalData.id);
      if (!alive) return;

      if (!userProgress) {
        navigate("/journal/the-untangle-journal/intro", { replace: true });
      } else {
        setProgress(userProgress);
        setStatus("home");
      }
    };

    run();

    return () => {
      alive = false;
    };
  }, [navigate]);

  if (status === "checking") {
    return (
      <div className="mmr-gate">
        <p className="mmr-gate-text">Loading your journal…</p>
      </div>
    );
  }

  if (status === "home") {
    return <UntangleHome journal={journal} progress={progress} />;
  }

  return null;
}

export default UntangleRouter;
